import React, { useState, useEffect } from 'react'
import './navbar.css';

function Navbar() {
  
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false); // Close mobile menu after clicking
    }
  };

  return (
    <div className={`navbar `}>
      <div className="navLogo">
        <img src='logo.jpeg' alt='logo' className='logo'/>
        <h5 className="logoText">Purplee Edge<br/> <span className='logoEnhanced'> Enterprises LLP</span></h5>
      </div>
      
      <div className="hamburger" onClick={toggleMenu}>
        <div className={`hamburger-line ${menuOpen ? 'open' : ''}`}></div>
        <div className={`hamburger-line ${menuOpen ? 'open' : ''}`}></div>
        <div className={`hamburger-line ${menuOpen ? 'open' : ''}`}></div>
      </div>
      
      <div className={`navItems ${menuOpen ? 'open' : ''}`}>
        <h5 className="itemText" onClick={() => scrollToSection('about')}>About Us</h5>
        <h5 className="itemText" onClick={() => scrollToSection('approach')}>Our Approach</h5>
        <h5 className="itemText" onClick={() => scrollToSection('services')}>Service</h5>
        <h5 className="itemText" onClick={() => scrollToSection('contact')}>Contact Us</h5>
      </div>
    </div>
  )
}

export default Navbar